export const searchConfig = {
  isAdvanced: true,
  formItems: [],
  filedOptions: [
    {
      fieldName: "ord_no",
      displayName: "订单号",
      condition: [
        {
          code: "=",
          name: "等于",
        },
        {
          code: "like",
          name: "包含",
        },
      ],
      textType: "input",
    },
    {
      fieldName: "ord_status",
      displayName: "订单状态",
      condition: [
        {
          code: "=",
          name: "等于",
        },
      ],
      textType: "select",
      dictCode: "getOrderStatusList",
    },
    {
      fieldName: "ord_approval_id",
      displayName: "结算状态",
      condition: [
        {
          code: "=",
          name: "等于",
        },
      ],
      textType: "select",
      dictCode: "getOrdAppList",
    },

    {
      fieldName: "ord_remark",
      displayName: "订单备注",
      condition: [
        {
          code: "=",
          name: "等于",
        },
        {
          code: "like",
          name: "包含",
        },
      ],
      textType: "input",
    },
  ],
};
